import React from 'react';
import { Row, Col } from 'reactstrap';
import filterIcon from "../../assets/icons/filter_icon.svg";
import { connect } from "react-redux";
import { toggleFilter, onClearFilters } from '../../actions/filterActions';
import PageHeader from '../PageHeader/PageHeader';

const Filter = (props) => {

    const { filterShow } = props.filter;
    const tooltipCode = props.tooltipCode || props.tootipCode;
    const showTitle = props.asTitle !== false;

    const actions = (
        <div className="filter_bar filter_bar--inline">
            {props.showButtons ? props.buttons : null}
            <div className="filter_sec">
                            <button
                                className="btn p-0"
                                onClick={() => props.toggleFilter(true)}
                                style={{ width: "auto" }}
                            >
                                <img src={filterIcon} alt="" width={27} height={27} />
                            </button>
                            <div
                                className={`filter_backdrop ${filterShow ? "active" : ""
                                    }`}
                            ></div>
                            <div
                                className={`filter_content ${filterShow ? "active" : ""
                                    }`}
                            >
                                <div className="position-relative">
                                    <div className="top_bar">
                                        <h3>Filters</h3>
                                        <button
                                            className="btn p-0"
                                            onClick={() => {
                                                props.toggleFilter(false);
                                                props.onClearFilters();
                                                props.onClearFilterHandler();
                                            }}>
                                            Clear Filters
                                        </button>
                                    </div>
                                    <div className="filter_items_container">
                                        {props.children}
                                    </div>
                                    <div className="bottom_bar">
                                        <button
                                            className="btn btn-outline"
                                            onClick={() => props.toggleFilter(false)}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-app"
                                            onClick={props.onFilterRecords}
                                        >
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
        </div>
    );

    if (!showTitle) {
        return actions;
    }

    return (
        <Row>
            <Col sm="12">
                <PageHeader
                    title={props.name}
                    subtitle={props.subtitle}
                    tooltipCode={tooltipCode}
                    level={props.level || "page"}
                    actions={actions}
                />
            </Col>
        </Row>
    )
}

const mapStateToProps = (state) => ({
    filter: state.filter
});

export default connect(mapStateToProps, {
    toggleFilter,
    onClearFilters
})(Filter);
